import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faLayerGroup, faSchool, faUsers } from '@fortawesome/free-solid-svg-icons';
import StatusCard from 'components/StatusCard';
import history from 'components/history';

import 'assets/styles/account.css';
import 'assets/styles/workspace.css';

export default function ClassWorkspaceLayout({ title, subtitle, classLabel, studentCount, levels, user, children }) {
    return (
        <main className="ae-account-page ae-workspace-page">
            <div className="ae-account-ring ae-account-ring--violet" />
            <div className="ae-account-ring ae-account-ring--green" />
            <div className="ae-account-ring ae-account-ring--gold" />

            <div className="ae-account-content ae-workspace-content">
                <div className="ae-workspace-toolbar">
                    <button type="button" className="ae-workspace-back" onClick={() => history.goBack()}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <span>Retour</span>
                    </button>

                    <div className="ae-workspace-profile" aria-label={`Profil connecté : ${user.pseudo || ''}`}>
                        <img
                            src={`${process.env.PUBLIC_URL}/img/avatars/avatar_${user.id_avatar || 0}.png`}
                            alt=""
                        />
                        <span>
                            <small>Profil connecté</small>
                            <strong>{user.pseudo || 'Utilisateur'}</strong>
                        </span>
                    </div>
                </div>

                <header className="ae-account-heading ae-workspace-heading">
                    <h1>{title}</h1>
                    <p>{subtitle}</p>
                </header>

                <section className="ae-account-stat-grid ae-workspace-stat-grid" aria-label="Informations de la classe">
                    <StatusCard
                        color="blue"
                        icon={faSchool}
                        title="Classe"
                        amount={classLabel || ''}
                    />
                    <StatusCard
                        color="pink"
                        icon={faUsers}
                        title="Nombre d'élèves"
                        amount={studentCount !== undefined ? studentCount.toString() : ''}
                    />
                    <StatusCard
                        color="green"
                        icon={faLayerGroup}
                        title="Niveau(x) de la classe"
                        amount={levels || ''}
                    />
                </section>

                <div className="ae-workspace-sections">{children}</div>

                <footer className="ae-account-copyright">© 2024 Accès EPS — Tous droits réservés</footer>
            </div>
        </main>
    );
}
